import { render, staticRenderFns } from "./BotMenuSections.vue?vue&type=template&id=5a6cb040&scoped=true"
import script from "./BotMenuSections.vue?vue&type=script&lang=js"
export * from "./BotMenuSections.vue?vue&type=script&lang=js"
import style0 from "./BotMenuSections.vue?vue&type=style&index=0&id=5a6cb040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cb040",
  null
  
)

export default component.exports